// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logo.jpeg";
import logo from "./assets/logo.jpeg";
// Profile Image
import profile from "./assets/profile.png";
// Tech stack images 
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import react from "./assets/techstack/react.png";
import redux from "./assets/techstack/redux.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/techstack/github.png";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import streamlit from "./assets/techstack/streamlit.png";
import python from "./assets/techstack/python.jpg"
import mongodb from "./assets/techstack/mongo.png"
import flask from "./assets/techstack/flask.png"

// Porject Images
import projectImage1 from "./assets/projects/project1.gif";
import projectImage2 from "./assets/projects/project2.jpg";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "Sanjana Patil",
  tagline: "I build things for web.",
  img: profile,
  about: "",
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/sanjana-patil-26a08b222",
  github: "https://github.com/sanjanapatil-js",
  twitter : "https://www.instagram.com/patil_sanjana10___",
  

};

// Enter your Work Experience here
export const workDetails = [
  
  
  {
    Position: "JAVA FULLSTACK INTERN",
    Company: "Exucia Infotech",
    Location: "Pune",
    Type: "Internship",
    Duration: "Jan 2024 - Present",
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "MCA",
    Company: "Suryadatta Instiute of Managemnet & Mass Communication (SIMMC)",
    Location: "Pune",
    Type: "Full Time",
    Duration: "Present",
  },
  {
    Position: "BCS",
    Company: "Art Science Commerce College",
    Location: "Naldurg",
    Type: "Full Time",
    Duration: "2022",
  },
  {
    Position: "HSC",
    Company: "Art Science Commerce College",
    Location: "Naldurg",
    Type: "Full Time",
    Duration: "2019",
  },
  {
    Position: "SSC",
    Company: "Dharitri  Vidyalaya Allyabad",
    Location: "Naldurg",
    Type: "Full Time",
    Duration: "2017",
  },
  
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  react: react,
  redux: redux,
  sass: sass,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  streamlit: streamlit,
  npm: npm,
  git: git,
  github: github,
  python:python,
  mongodb:mongodb,
  flask:flask,
  
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "MovieZing",
    image: projectImage1,
    description: "Created a modern movie streaming app with robust user authentication, personalized content features, and seamless playback. Continuously updated with the latest releases for an up-to-date library",
    techstack: "React js , mongoDB , firebase , API ",
    previewLink: "https://moviezing-1.web.app/",
    githubLink: "https://github.com",
  },
  {
    title: "Pet Shop",
    image: projectImage2,
    description: "Developed a user-friendly pet shop platform for admins to effortlessly manage products and pets. Designed intuitive features for adding, editing, and removing items. Ensured secure login, responsive design, and efficient database management. Integrated payment gateways for seamless transactions.",
    techstack: "HTML/CSS, JavaScript, PHP, SQL",
    previewLink: "#",
    githubLink: "",
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "patilsanjana10008@gmail.com",
  
};